// extracted by mini-css-extract-plugin
export var container = "_a9-0";
export var containerTopRight = "_a9-1";